import { http } from './config'

export default {

  getAll: () => {
    return http.get('pallet_types')
  },
  getPalletType: (id) => {
    return http.get(`pallet_types/${id}`)
  },

  getByLocality: (localityId) => {
    return http.get(`pallet_types/by_locality/${localityId}`)
  },

  update: (params) => {
    return http.put(`pallet_types/${params.id}`, {
      pallet_type: {
        assembling_timeout: params.assembling_timeout,
        minimum_assembly_time: params.minimum_assembly_time,
        sort_type_id: params.sort_type.id,
        active: params.active
      }
    })
  }
}
